import { useState, useEffect } from "react";

export enum BroadcastChannels {
  PIN = "pin",
  SESSION = "session",
}

export type BroadcastChannelMap = {
  [key in BroadcastChannels]?: BroadcastChannel | undefined;
};

const useBroadcastChannel = (): BroadcastChannelMap => {
  const [channelMap, setChannelMap] = useState<BroadcastChannelMap>({});

  useEffect(() => {
    const c = new BroadcastChannel(BroadcastChannels.PIN);
    const s = new BroadcastChannel(BroadcastChannels.SESSION);
    setChannelMap({
      [BroadcastChannels.PIN]: c,
      [BroadcastChannels.SESSION]: s,
    });
  }, []);

  return channelMap;
};

export default useBroadcastChannel;
